import { LarosateResult, UrvalsgruppResult, AstaQuery, SearchResult } from '../../types/AstaTypes';
const baseUrl = '/api/antagningsstatistik';

const getQueryParameters = (AstaResultatStatus: AstaQuery, resultlimit: number = 0): string => {
  let queryParameter =
    '?searchfor=' +
    AstaResultatStatus.searchfor +
    '&searchterm=' +
    AstaResultatStatus.searchterm +
    '&searchkategori=' +
    AstaResultatStatus.searchkategori +
    (resultlimit != 0 ? '&pagesize=' + resultlimit : '') +
    '&page=' +
    AstaResultatStatus.page +
    '&tillfalle=' +
    AstaResultatStatus.tillfalle;

  const hasLarosaten = AstaResultatStatus.larosaten != null && AstaResultatStatus.larosaten.length > 0;
  if (hasLarosaten) {
    queryParameter = queryParameter.concat('&larosaten=' + AstaResultatStatus.larosaten.join(','));
  }

  const hasValidUtbildningstyp = AstaResultatStatus.utbildningstyp === 'program' || AstaResultatStatus.utbildningstyp === 'kurs';
  if (hasValidUtbildningstyp) {
    queryParameter = queryParameter.concat('&utbildningstyp=' + AstaResultatStatus.utbildningstyp);
  }

  const hasValidSort = !!AstaResultatStatus.sorteringskolumn && AstaResultatStatus.sorteringskolumn.length > 0;
  if (hasValidSort) {
    queryParameter = queryParameter.concat('&sorteringskolumn=' + AstaResultatStatus.sorteringskolumn);
  }

  const isPoangUrval = AstaResultatStatus.vy === 'antagningspoang-urv1' || AstaResultatStatus.vy === 'antagningspoang-urv2';
  const hasSorteringsurvalGrupp = AstaResultatStatus.sorteringsurvalsgrupp !== null && AstaResultatStatus.sorteringsurvalsgrupp !== '';
  if (isPoangUrval && hasSorteringsurvalGrupp) {
    queryParameter = queryParameter.concat('&sorteringsurvalsgrupp=' + AstaResultatStatus.sorteringsurvalsgrupp);
  }

  if (AstaResultatStatus.sorteringsordningdesc === true) {
    queryParameter = queryParameter.concat('&sorteringsordningdesc=true');
  }

  return queryParameter;
};

export const suggest = async (searchfor: string, searchterm: string, pagesize?: number) => {
  const response = await fetch(`${baseUrl}/suggest?searchfor=${searchfor}&searchterm=${searchterm}&pagesize=${pagesize}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

export const astaV2Search = async (queryData: AstaQuery, resultlimit: number = 10): Promise<SearchResult> => {
  const queryParameters = getQueryParameters(queryData, resultlimit);
  const response = await fetch(`${baseUrl}/searchTotal${queryParameters}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

//clearCache
export const clearCache = async (searchterm: string = '') => {
  const response = await fetch(`${baseUrl}/clearCache?searchterm=${searchterm}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

//doAstaLarosaten
export const larosaten = async (queryData: AstaQuery): Promise<LarosateResult> => {
  const queryParameters = getQueryParameters(queryData);
  const response = await fetch(`${baseUrl}/larosaten${queryParameters}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

//doAstaUrvalsgrupper
export const urvalsgrupper = async (queryData: AstaQuery): Promise<UrvalsgruppResult> => {
  const queryParameters = getQueryParameters(queryData);
  const response = await fetch(`${baseUrl}/urvalsgrupper${queryParameters}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

//doFileDownload
export const fileDownload = (queryData: AstaQuery, fileType: 'csv' | 'excel') => {
  console.log('TODO: implementera fileDownload', queryData, fileType);
  //parametrarna är desamma som för astaV2Search mfl. och fås genom getQueryParameters anropern är endera /csv eller /excel
};

//Ej implementerade: (verkar inte användas)
//searchfor
//utbildningar
